<template>
    <v-container grid-list-md fluid>
        <template v-if="!$vuetify.display.mobile">
            <v-layout wrap>
                <v-flex xs12 sm5>
                    <v-btn-back @click.stop="back()" v-if="mode != 'GeneralLedger' && goBackHistory"> </v-btn-back>
                    <div
                        style="
                            position: relative;
                            width: 100%;
                            height: 0;
                            padding: 0;
                            padding-bottom: 141.4516129032258%;
                            margin-bottom: 50px;
                        "
                    >
                        <svg
                            id="svg-document-validation-payslip-static"
                            v-if="document"
                            xmlns="http://www.w3.org/2000/svg"
                            width="100%"
                            :viewBox="`0 0 ${imageWidth} ${imageHeight}`"
                            style="position: absolute; width: 100%; left: 0; top: 0"
                        >
                            <g>
                                <image
                                    id="svg-image-document-validation-payslip-static"
                                    :xlink:href="document.signedUrl"
                                    x="0"
                                    y="0"
                                    :height="`${imageHeight}px`"
                                    :width="`${imageWidth}px`"
                                />
                                <template
                                    v-for="(variant, index) in svgVariants"
                                    :key="`coord-${document.id}-${index}`"
                                >
                                    <template
                                        v-for="(coord, index2) in variant.coordinates"
                                        :key="`coord-${document.id}-${index}-${index2}`"
                                    >
                                        <polygon
                                            :ref="`variants-${index}-${index2}`"
                                            :points="getPoints(coord)"
                                            :style="
                                                variant.active
                                                    ? 'fill:rgba(250,250,250,0.5);stroke:lime;stroke-width:1'
                                                    : 'fill:rgba(250,250,250,0.5);stroke:gray;stroke-width:1;cursor:pointer'
                                            "
                                            @click.stop="
                                                variant.active
                                                    ? ''
                                                    : showCorrespondingField({
                                                          variant,
                                                          currentIndex: index,
                                                          copyIndex: index2,
                                                      })
                                            "
                                            :class="variant.focus ? 'highlighted' : ''"
                                        />
                                    </template>
                                </template>
                            </g>
                        </svg>
                    </div>
                </v-flex>
                <v-list v-if="associatedFields.show" :style="svgPosition">
                    <v-list-item
                        v-for="(field, key, index) in associatedFields.fields"
                        :key="`field-${document.id}-${key}-${index}`"
                        @click="onFieldAssociation(field, key)"
                        class="oss-list-item"
                    >
                    </v-list-item>
                </v-list>
                <v-flex xs12 sm7>
                    <v-card
                        style="
                            position: fixed;
                            margin-top: -3vh;
                            max-height: 80vh;
                            overflow-y: auto;
                        "
                        class="default_card_wm"
                    >
                        <v-card-title style="padding-bottom: 0; padding-top: 5px">
                            <h3>Détails</h3>
                            <v-spacer />
                            <v-btn-icon
                                icon="$cloud_download"
                                color="secondary"
                                @click="startDownloadFile"
                            />

                            <v-btn-icon
                                icon="$oss-scan"
                                color="secondary"
                                @click="analyseDocumentDialog = true"
                                v-if="restartAnalysis"
                            />
                            <!-- <v-btn
                            icon
                            @click="deleteDocumentDialog = true"
                            :disabled="disabledDelete"
                            :input-value="!disabledDelete"
                            color="error"
                            >
                            <v-icon>$delete</v-icon>
                        </v-btn> -->
                        </v-card-title>
                        <v-card-text style="padding-top: 0">
                            <v-form ref="form" v-model="valid" v-if="form['date']">
                                <v-flex xs12>
                                    <div style="margin: 0 auto">
                                        <div xs3 style="display: flex">
                                            <v-text-field-filled
                                                @mouseover="highlightField(form.grossSalary, true)"
                                                @mouseout="highlightField(form.grossSalary, false)"
                                                regular
                                                outlined
                                                class="mr-1"
                                                :hide-details="true"
                                                readonly
                                                label="Salarié"
                                                :model-value="
                                                    getUserDisplayName(currentAccountUser)
                                                "
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <v-flex>
                                            <v-text-field-filled
                                                @mouseover="highlightField(form.grossSalary, true)"
                                                @mouseout="highlightField(form.grossSalary, false)"
                                                regular
                                                outlined
                                                class="mr-1"
                                                :hide-details="true"
                                                readonly
                                                :model-value="formatDate(form['date'].value)"
                                            />
                                        </v-flex>
                                        <!-- grossSalary -->
                                        <v-text-field-filled
                                            @mouseover="highlightField(form.grossSalary, true)"
                                            @mouseout="highlightField(form.grossSalary, false)"
                                            regular
                                            outlined
                                            class="mr-1"
                                            :hide-details="true"
                                            readonly
                                            :model-value="
                                                newCommonFormatCurrency(
                                                    form.grossSalary.value,
                                                    undefined,
                                                )
                                            "
                                        />
                                        <div xs3 style="display: flex">
                                            <!-- salaryCharges -->
                                            <v-text-field-filled
                                                @mouseover="
                                                    highlightField(form.salaryCharges, true)
                                                "
                                                @mouseout="
                                                    highlightField(form.salaryCharges, false)
                                                "
                                                regular
                                                outlined
                                                class="mr-1"
                                                :hide-details="true"
                                                readonly
                                                :model-value="
                                                    newCommonFormatCurrency(
                                                        form.salaryCharges.value,
                                                        undefined,
                                                    )
                                                "
                                            />
                                            <!-- employerCharges -->
                                            <v-text-field-filled
                                                @mouseover="
                                                    highlightField(form.employerCharges, true)
                                                "
                                                @mouseout="
                                                    highlightField(form.employerCharges, false)
                                                "
                                                regular
                                                outlined
                                                class="mr-1"
                                                :hide-details="true"
                                                readonly
                                                :model-value="
                                                    newCommonFormatCurrency(
                                                        form.employerCharges.value,
                                                        undefined,
                                                    )
                                                "
                                            />
                                        </div>
                                        <div xs3 style="display: flex">
                                            <!-- nonDeductibleCSGCRDS -->
                                            <v-text-field-filled
                                                @mouseover="
                                                    highlightField(form.nonDeductibleCSGCRDS, true)
                                                "
                                                @mouseout="
                                                    highlightField(form.nonDeductibleCSGCRDS, false)
                                                "
                                                regular
                                                outlined
                                                class="mr-1"
                                                :hide-details="true"
                                                readonly
                                                :model-value="
                                                    newCommonFormatCurrency(
                                                        form.nonDeductibleCSGCRDS.value,
                                                        undefined,
                                                    )
                                                "
                                            />
                                            <!-- hshc -->
                                            <v-text-field-filled
                                                @mouseover="highlightField(form.hshc, true)"
                                                @mouseout="highlightField(form.hshc, false)"
                                                regular
                                                outlined
                                                class="mr-1"
                                                :hide-details="true"
                                                readonly
                                                :model-value="
                                                    newCommonFormatCurrency(
                                                        form.hshc.value,
                                                        undefined,
                                                    )
                                                "
                                            />
                                        </div>
                                        <div xs3 style="display: flex">
                                            <!-- navigo -->
                                            <v-text-field-filled
                                                @mouseover="highlightField(form.navigo, true)"
                                                @mouseout="highlightField(form.navigo, false)"
                                                regular
                                                outlined
                                                class="mr-1"
                                                :hide-details="true"
                                                readonly
                                                :model-value="
                                                    newCommonFormatCurrency(
                                                        form.navigo.value,
                                                        undefined,
                                                    )
                                                "
                                            />

                                            <!-- benefitInKind -->
                                            <v-text-field-filled
                                                @mouseover="
                                                    highlightField(form.benefitInKind, true)
                                                "
                                                @mouseout="
                                                    highlightField(form.benefitInKind, false)
                                                "
                                                regular
                                                outlined
                                                class="mr-1"
                                                :hide-details="true"
                                                readonly
                                                :model-value="
                                                    newCommonFormatCurrency(
                                                        form.benefitInKind.value,
                                                        undefined,
                                                    )
                                                "
                                            />
                                            <!-- luncheonVoucher -->
                                            <v-text-field-filled
                                                @mouseover="
                                                    highlightField(form.luncheonVoucher, true)
                                                "
                                                @mouseout="
                                                    highlightField(form.luncheonVoucher, false)
                                                "
                                                regular
                                                outlined
                                                class="mr-1"
                                                :hide-details="true"
                                                readonly
                                                :model-value="
                                                    newCommonFormatCurrency(
                                                        form.luncheonVoucher.value,
                                                        undefined,
                                                    )
                                                "
                                            />
                                        </div>
                                        <div xs3 style="display: flex">
                                            <!-- employerLoan -->
                                            <v-text-field-filled
                                                @mouseover="highlightField(form.employerLoan, true)"
                                                @mouseout="highlightField(form.employerLoan, false)"
                                                regular
                                                outlined
                                                class="mr-1"
                                                :hide-details="true"
                                                readonly
                                                :model-value="
                                                    newCommonFormatCurrency(
                                                        form.employerLoan.value,
                                                        undefined,
                                                    )
                                                "
                                            />

                                            <!-- thirdPartyNotification -->
                                            <v-text-field-filled
                                                @mouseover="
                                                    highlightField(
                                                        form.thirdPartyNotification,
                                                        true,
                                                    )
                                                "
                                                @mouseout="
                                                    highlightField(
                                                        form.thirdPartyNotification,
                                                        false,
                                                    )
                                                "
                                                regular
                                                outlined
                                                class="mr-1"
                                                :hide-details="true"
                                                readonly
                                                :model-value="
                                                    newCommonFormatCurrency(
                                                        form.thirdPartyNotification.value,
                                                        undefined,
                                                    )
                                                "
                                            />
                                        </div>
                                        <!-- netSalaryBeforeTax -->
                                        <v-text-field-filled
                                            @mouseover="
                                                highlightField(form.netSalaryBeforeTax, true)
                                            "
                                            @mouseout="
                                                highlightField(form.netSalaryBeforeTax, false)
                                            "
                                            regular
                                            outlined
                                            class="mr-1"
                                            :hide-details="true"
                                            readonly
                                            :model-value="
                                                newCommonFormatCurrency(
                                                    form.netSalaryBeforeTax.value,
                                                    undefined,
                                                )
                                            "
                                        />
                                        <!-- incomeTax -->
                                        <v-text-field-filled
                                            @mouseover="highlightField(form.incomeTax, true)"
                                            @mouseout="highlightField(form.incomeTax, false)"
                                            regular
                                            outlined
                                            class="mr-1"
                                            :hide-details="true"
                                            readonly
                                            :model-value="
                                                newCommonFormatCurrency(
                                                    form.incomeTax.value,
                                                    undefined,
                                                )
                                            "
                                        />
                                        <!-- netSalaryPaid -->
                                        <v-text-field-filled
                                            @mouseover="highlightField(form.netSalaryPaid, true)"
                                            @mouseout="highlightField(form.netSalaryPaid, false)"
                                            regular
                                            outlined
                                            class="mr-1"
                                            :hide-details="true"
                                            readonly
                                            :model-value="
                                                newCommonFormatCurrency(
                                                    form.netSalaryPaid.value,
                                                    undefined,
                                                )
                                            "
                                        />
                                        <!-- totalCost -->
                                        <v-text-field-filled
                                            @mouseover="highlightField(form.totalCost, true)"
                                            @mouseout="highlightField(form.totalCost, false)"
                                            regular
                                            outlined
                                            class="mr-1"
                                            :hide-details="true"
                                            readonly
                                            :model-value="
                                                newCommonFormatCurrency(
                                                    form.totalCost.value,
                                                    undefined,
                                                )
                                            "
                                        />
                                    </div>
                                </v-flex>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </template>
        <!-- SmartPhone -->
        <template v-else>
            <v-layout wrap>
                <v-flex xs12 sm7 style="display: flex">
                    <v-switch
                        v-model="showDocument"
                        hide-details
                        label="Afficher le document"
                        class="my-0 py-0"
                    />
                    <!-- <v-btn outlined size=“x-small” color="secondary" @click="showDocument = !showDocument" style="margin: 0 auto">Afficher le document</v-btn> -->
                    <!-- <v-spacer></v-spacer>
                    <v-btn
                            class="btn"
                             size="small"
                            color="secondary"
                            :disabled="disabledValidate"
                            @click="onFormValidation()"
                        >
                            {{ validated ? 'Validé' : 'Valider' }}
                            <v-icon v-show="validated">$check</v-icon>
                        </v-btn> -->
                </v-flex>
                <v-flex xs12 sm7 @click="showDocument = false" v-if="showDocument">
                    <div style="text-align: center; width: 100%">
                        <div
                            style="
                                position: relative;
                                width: 100%;
                                height: 0;
                                padding: 0;
                                padding-bottom: 141.4516129032258%;
                            "
                        >
                            <svg
                                id="svg-document-validation-payslip-static"
                                v-if="document"
                                xmlns="http://www.w3.org/2000/svg"
                                width="100%"
                                :viewBox="`0 0 ${imageWidth} ${imageHeight}`"
                                style="position: absolute; width: 100%; left: 0; top: 0"
                                class="elevation-2"
                            >
                                <image
                                    id="svg-image-document-validation-payslip-static"
                                    :xlink:href="document.signedUrl"
                                    x="0"
                                    y="0"
                                    :height="`${imageHeight}px`"
                                    :width="`${imageWidth}px`"
                                />
                            </svg>
                        </div>
                    </div>
                </v-flex>
                <v-flex>
                    <v-text-field
                        @mouseover="highlightField(form.grossSalary, true)"
                        @mouseout="highlightField(form.grossSalary, false)"
                        regular
                        class="mr-1"
                        :hide-details="true"
                        readonly
                        label="Salarié"
                        :model-value="getUserDisplayName(currentAccountUser)"
                    >
                    </v-text-field>
                </v-flex>
                <div>
                    <v-flex>
                        <v-text-field
                            @mouseover="highlightField(form.grossSalary, true)"
                            @mouseout="highlightField(form.grossSalary, false)"
                            regular
                            class="mr-1"
                            :hide-details="true"
                            readonly
                            :model-value="formatDate(form['date'].value)"
                        >
                            <template #label> Date du document </template>
                        </v-text-field>
                    </v-flex>
                    <!-- grossSalary -->
                    <v-text-field
                        @mouseover="highlightField(form.grossSalary, true)"
                        @mouseout="highlightField(form.grossSalary, false)"
                        regular
                        class="mr-1"
                        :hide-details="true"
                        readonly
                        :model-value="newCommonFormatCurrency(form.grossSalary.value, undefined)"
                    >
                        <template #label>
                            {{ $t("document.social.grossSalary") }}
                        </template>
                    </v-text-field>
                    <div xs3 style="display: flex">
                        <!-- salaryCharges -->
                        <v-text-field
                            @mouseover="highlightField(form.salaryCharges, true)"
                            @mouseout="highlightField(form.salaryCharges, false)"
                            regular
                            class="mr-1"
                            :hide-details="true"
                            readonly
                            :model-value="
                                newCommonFormatCurrency(form.salaryCharges.value, undefined)
                            "
                        >
                            <template #label>
                                {{ $t("document.social.salaryCharges") }}
                            </template>
                        </v-text-field>
                        <!-- employerCharges -->
                        <v-text-field
                            @mouseover="highlightField(form.employerCharges, true)"
                            @mouseout="highlightField(form.employerCharges, false)"
                            regular
                            class="mr-1"
                            :hide-details="true"
                            readonly
                            :model-value="
                                newCommonFormatCurrency(form.employerCharges.value, undefined)
                            "
                        >
                            <template #label>
                                {{ $t("document.social.employerCharges") }}
                            </template>
                        </v-text-field>
                    </div>
                    <div xs3 style="display: flex">
                        <!-- nonDeductibleCSGCRDS -->
                        <v-text-field
                            @mouseover="highlightField(form.nonDeductibleCSGCRDS, true)"
                            @mouseout="highlightField(form.nonDeductibleCSGCRDS, false)"
                            regular
                            class="mr-1"
                            :hide-details="true"
                            readonly
                            :model-value="
                                newCommonFormatCurrency(form.nonDeductibleCSGCRDS.value, undefined)
                            "
                        >
                            <template #label>
                                {{ $t("document.social.nonDeductibleCSGCRDS") }}
                            </template>
                        </v-text-field>
                        <!-- hshc -->
                        <v-text-field
                            @mouseover="highlightField(form.hshc, true)"
                            @mouseout="highlightField(form.hshc, false)"
                            regular
                            class="mr-1"
                            :hide-details="true"
                            readonly
                            :model-value="newCommonFormatCurrency(form.hshc.value, undefined)"
                        >
                            <template #label>
                                {{ $t("document.social.hshc") }}
                            </template>
                        </v-text-field>
                    </div>
                    <div xs3 style="display: flex">
                        <!-- navigo -->
                        <v-text-field
                            @mouseover="highlightField(form.navigo, true)"
                            @mouseout="highlightField(form.navigo, false)"
                            regular
                            class="mr-1"
                            :hide-details="true"
                            readonly
                            :model-value="newCommonFormatCurrency(form.navigo.value, undefined)"
                        >
                            <template #label>
                                {{ $t("document.social.navigo") }}
                            </template>
                        </v-text-field>

                        <!-- benefitInKind -->
                        <v-text-field
                            @mouseover="highlightField(form.benefitInKind, true)"
                            @mouseout="highlightField(form.benefitInKind, false)"
                            regular
                            class="mr-1"
                            :hide-details="true"
                            readonly
                            :model-value="
                                newCommonFormatCurrency(form.benefitInKind.value, undefined)
                            "
                        >
                            <template #label>
                                {{ $t("document.social.benefitInKind") }}
                            </template>
                        </v-text-field>
                        <!-- luncheonVoucher -->
                        <v-text-field
                            @mouseover="highlightField(form.luncheonVoucher, true)"
                            @mouseout="highlightField(form.luncheonVoucher, false)"
                            regular
                            class="mr-1"
                            :hide-details="true"
                            readonly
                            :model-value="
                                newCommonFormatCurrency(form.luncheonVoucher.value, undefined)
                            "
                        >
                            <template #label>
                                {{ $t("document.social.luncheonVoucher") }}
                            </template>
                        </v-text-field>
                    </div>
                    <div xs3 style="display: flex">
                        <!-- employerLoan -->
                        <v-text-field
                            @mouseover="highlightField(form.employerLoan, true)"
                            @mouseout="highlightField(form.employerLoan, false)"
                            regular
                            class="mr-1"
                            :hide-details="true"
                            readonly
                            :model-value="
                                newCommonFormatCurrency(form.employerLoan.value, undefined)
                            "
                        >
                            <template #label>
                                {{ $t("document.social.employerLoan") }}
                            </template>
                        </v-text-field>

                        <!-- thirdPartyNotification -->
                        <v-text-field
                            @mouseover="highlightField(form.thirdPartyNotification, true)"
                            @mouseout="highlightField(form.thirdPartyNotification, false)"
                            regular
                            class="mr-1"
                            :hide-details="true"
                            readonly
                            :model-value="
                                newCommonFormatCurrency(
                                    form.thirdPartyNotification.value,
                                    undefined,
                                )
                            "
                        >
                            <template #label>
                                {{ $t("document.social.thirdPartyNotification") }}
                            </template>
                        </v-text-field>
                    </div>
                    <!-- netSalaryBeforeTax -->
                    <v-text-field
                        @mouseover="highlightField(form.netSalaryBeforeTax, true)"
                        @mouseout="highlightField(form.netSalaryBeforeTax, false)"
                        regular
                        class="mr-1"
                        :hide-details="true"
                        readonly
                        :model-value="
                            newCommonFormatCurrency(form.netSalaryBeforeTax.value, undefined)
                        "
                    >
                        <template #label>
                            {{ $t("document.social.netSalaryBeforeTax") }}
                        </template>
                    </v-text-field>
                    <!-- incomeTax -->
                    <v-text-field
                        @mouseover="highlightField(form.incomeTax, true)"
                        @mouseout="highlightField(form.incomeTax, false)"
                        regular
                        class="mr-1"
                        :hide-details="true"
                        readonly
                        :model-value="newCommonFormatCurrency(form.incomeTax.value, undefined)"
                    >
                        <template #label>
                            {{ $t("document.social.incomeTax") }}
                        </template>
                    </v-text-field>
                    <!-- netSalaryPaid -->
                    <v-text-field
                        @mouseover="highlightField(form.netSalaryPaid, true)"
                        @mouseout="highlightField(form.netSalaryPaid, false)"
                        regular
                        class="mr-1"
                        :hide-details="true"
                        readonly
                        :model-value="newCommonFormatCurrency(form.netSalaryPaid.value, undefined)"
                    >
                        <template #label>
                            {{ $t("document.social.netSalaryPaid") }}
                        </template>
                    </v-text-field>
                    <!-- totalCost -->
                    <v-text-field
                        @mouseover="highlightField(form.totalCost, true)"
                        @mouseout="highlightField(form.totalCost, false)"
                        regular
                        class="mr-1"
                        :hide-details="true"
                        readonly
                        :model-value="newCommonFormatCurrency(form.totalCost.value, undefined)"
                    >
                        <template #label>
                            {{ $t("document.social.totalCost") }}
                        </template>
                    </v-text-field>
                </div>
            </v-layout>
        </template>
        <div class="text-center" v-if="!$vuetify.display.mobile">
            <div class="bottom-sheet">
                <div class="remote">
                    <v-container class="controller" elevation-1 style="pointer-events: auto">
                        <!-- <template v-if="!otherOnlineUsersWrite"><b >Action :</b> {{advice}}</template>
                        <template v-else><v-icon color="warning">$warning</v-icon><b> En cours de modification par un autre utilisateur</b></template> -->
                        <v-btn
                            :disabled="zoomManager.disableZoomOut()"
                            class="btn"
                            rounded="circle"
                            size="x-small"
                            @click.stop="zoomManager.zoomOut()"
                            icon="$zoom_out"
                        >
                        </v-btn>
                        <v-btn
                            :disabled="zoomManager.disableResetZoom()"
                            class="btn"
                            rounded="circle"
                            size="x-small"
                            @click.stop="zoomManager.resetZoom()"
                            icon="$center_focus_weak"
                        >
                        </v-btn>
                        <v-btn
                            :disabled="zoomManager.disableZoomIn()"
                            class="btn"
                            rounded="circle"
                            size="x-small"
                            @click.stop="zoomManager.zoomIn()"
                            icon="$zoom_in"
                        >
                        </v-btn>
                        <v-btn
                            :disabled="previousDisabled()"
                            class="btn"
                            rounded
                            size="small"
                            @click="previous()"
                        >
                            <v-icon>$navigate_before</v-icon>
                            <span>Précédent</span>
                        </v-btn>
                        <v-btn
                            class="btn"
                            rounded="circle"
                            size="x-small"
                            @click="stop()"
                            v-if="toBeDoneStatus"
                            icon="$stop"
                        >
                        </v-btn>
                        <v-btn
                            :disabled="nextDisabled()"
                            class="btn"
                            rounded
                            @click="next()"
                            size="small"
                        >
                            <span>Suivant</span>
                            <v-icon>$navigate_next</v-icon>
                        </v-btn>

                        <!-- <v-btn
                            class="btn"
                            outlined
                            color="secondary"
                            @click="setOpenChat('INFORMATION_REQUEST')"
                        >
                            <v-icon>$fa-comments</v-icon>
                            <span>Question</span>
                        </v-btn>
                        <v-btn
                            class="btn"
                            outlined
                            color="secondary"
                            @click="setOpenChat('DENIED')"
                        >
                            <v-icon>report_problem</v-icon>
                            <span>Rejeter</span>
                        </v-btn>
                        <v-btn
                            class="btn"
                            outlined
                            color="secondary"
                            @click="openReconciliation()"
                            v-if="activateReconciliation"
                        >
                            <v-icon>$compare_arrows</v-icon>
                            <span>Rapprochement</span>
                        </v-btn>
                        <v-btn
                            class="btn"
                            outlined
                            color="secondary"
                            :disabled="disabledValidate"
                            @click="onFormValidation(form)"
                        >
                            {{ validated ? 'Validé' : 'Valider' }}
                            <v-icon v-show="validated">$check</v-icon>
                        </v-btn> -->
                    </v-container>
                </div>
            </div>
        </div>
        <Chat
            v-if="openChat"
            v-bind:id="document.chat ? document.chat.id : ''"
            v-bind:inShowMessage="open_chat"
            v-bind:chatTitle="'Document'"
            v-bind:chatSubtitle="getChatSubTitle()"
            :showSmartChat="wishStatus !== 'DENIED'"
            @messageSent="onMessageSent($event)"
            @showMessageChanged="onShowMessageChanged($event)"
        />
        <oss-dialog v-model="dialogChooseDownload" title="Télécharger le document" width="80vw">
            Voulez-vous télécharger le document original ou marqué (numéro de pièce + horodaté).

            <template v-slot:actions>
                <v-row no-gutters>
                    <v-col cols="6" class="pr-2">
                        <v-btn-primary
                            rounded
                            block
                            @click="
                                dialogChooseDownload = false;
                                downloadFile(true);
                            "
                            size="x-large"
                            >Original</v-btn-primary
                        >
                    </v-col>
                    <v-col cols="6" class="pl-2">
                        <v-btn-primary
                            rounded
                            block
                            @click="
                                dialogChooseDownload = false;
                                downloadFile(false);
                            "
                            size="x-large"
                            >Marqué</v-btn-primary
                        >
                    </v-col>
                </v-row>
            </template>
        </oss-dialog>
        <oss-dialog
            v-model="analyseDocumentDialog"
            title="Relancer l'analyse du document"
            @valid="analyseDocument"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir relancer l'analyse ?</h4>
        </oss-dialog>
        <oss-dialog
            v-model="deleteDocumentDialog"
            title="Supprimer le document"
            :error="true"
            @valid="deleteDocument"
            :validTitle="'Oui je suis sûr(e)'"
            :validLoading="deleteDocumentLoading"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir supprimer le document ?</h4>
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import { DocumentValidationPaySlipBase } from "./DocumentValidationPaySlipBase";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class DocumentValidationPaySlip extends DocumentValidationPaySlipBase {
    showDocument: boolean = false;

    beforeMount() {
        this.svgSuffix = "document-validation-payslip-static";
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }
}

export default toNative(DocumentValidationPaySlip);
</script>
<style lang="scss" scoped>
.v-input--has-state.text-red .v-label {
    animation: none !important;
    transition: none !important;
}

.theme--light.v-label {
    color: black !important;
}

.svg-pan-zoom_viewport {
    transition: transform 0.4s ease-out !important;
}

.inline-text-field {
    max-width: 140px;
    margin-right: 10px;
    display: inline-block;
}

.text-field-icon--associated {
    display: flex;
}

i.inline-icon {
    display: flex;
    height: 55px;
    width: 30px;
}

polygon.highlighted {
    fill: rgba(249, 177, 42, 0.5) !important;
}

.v-input--is-disabled {
    pointer-events: all !important;
}
</style>
